import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52157ce0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar__content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__content" }, "Browse report", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"24px"} }, "-", -1))
const _hoisted_5 = {
  key: 1,
  class: "d-flex flex-wrap"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title" }, "Report result from : ", -1))
const _hoisted_7 = { class: "text__content mx-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__content" }, "-", -1))
const _hoisted_9 = { class: "text__content mx-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title ms-3 pe-2" }, "Status:", -1))
const _hoisted_11 = { class: "text__content pe-3" }
const _hoisted_12 = {
  key: 0,
  class: "text__title pe-2"
}
const _hoisted_13 = {
  key: 1,
  class: "text__content"
}
const _hoisted_14 = {
  key: 2,
  style: {"display":"flex"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title" }, "Report result from : ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__subtitle mx-2" }, "No Data", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isBrowseReport == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                class: "p-3",
                xs: 24,
                span: 5
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.config.riderStatus,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.riderStatus) = $event)),
                    placeholder: "Select",
                    style: {"width":"100%"},
                    onChange: _cache[1] || (_cache[1] = ($event: any) => {
              _ctx.fetchRiderList();
              _ctx.config.riderName = '';
            })
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                class: "p-3",
                xs: 24,
                span: 5
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_autocomplete, {
                    clearable: "",
                    modelValue: _ctx.config.riderName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.riderName) = $event)),
                    "fetch-suggestions": _ctx.querySearchAsync,
                    placeholder: "Search rider name",
                    debounce: 300,
                    style: {"width":"100%"},
                    "value-key": "name"
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "el-input__icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Search)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "fetch-suggestions"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                class: "p-3",
                xs: 24,
                span: 5
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.config.startDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.startDate) = $event)),
                    placeholder: "Start date",
                    name: "dueDate",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                span: 1,
                style: {"display":"flex","align-items":"center","justify-content":"center"}
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                class: "p-3",
                xs: 24,
                span: 5
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    style: {"width":"100%"},
                    modelValue: _ctx.config.endDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.config.endDate) = $event)),
                    placeholder: "End date",
                    name: "dueDate"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : (_ctx.originalConfig != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.moment(_ctx.originalConfig.startDate).format("YYYY/MM/DD")), 1),
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.moment(_ctx.originalConfig.endDate).format("YYYY/MM/DD")), 1),
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.originalConfig.riderStatus == 1
          ? "Active"
          : _ctx.originalConfig.riderStatus == 2
          ? "Pending"
          : _ctx.originalConfig.riderStatus == 3
          ? "Inactive"
          : ""), 1),
            (_ctx.originalConfig.riderName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Rider name:"))
              : _createCommentVNode("", true),
            (_ctx.originalConfig.riderName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.originalConfig.riderName), 1))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
  ]))
}